import { styled } from "@mui/material/styles";

type TagProps = {
  color?: string;
  bgColor?: string;
  markerColor?: string;
};

const StyledTag = styled("div")<TagProps>`
  width: max-content;
  max-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  gap: 8px;
  box-sizing: border-box;
  padding: 4px 16px;
  border-radius: 8px;
  flex-shrink: 0;
  user-select: none;

  background-color: ${({ bgColor, theme }) =>
    bgColor ?? theme.palette.primary.light};

  & > .tag__label {
    display: inline-block;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.bodyS?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyS?.lineHeight};
    color: ${({ color, theme }) => color ?? theme.palette.common.black};
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > .tag__marker {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ markerColor }) => markerColor};
  }
`;

export { StyledTag };
